import React, { useContext, useEffect, useRef } from 'react';
import styles from "./ProfileDrop.module.css";
import noteContext from '../Context/NoteContext';
import { SignOutButton } from "@clerk/clerk-react";

import { Link } from 'react-router-dom';
export default function ProfileDrop({ children }) {
    const { isProfile, setIsProfile } = useContext(noteContext);

    return (
        <>
            {/*Backdrop*/}
            {isProfile && (
                <div
                    onClick={() => setIsProfile(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 999,
                        backgroundColor: 'transparent'
                    }}
                />
            )}

            {/* 2. The Actual Dropdown Menu */}
            <div className={`${styles.ProfileDrop} ${isProfile ? styles.op : ""}`}>
                <div className={styles.HeaderArea}>
                    {children}
                </div>

                <ul className={styles.MenuList}>
                    <Link to="/Currency" className={styles.LinkWrapper}>
                        <li className={styles.MenuItem}>Currency</li>
                    </Link>

                    <Link to="/Inbox" className={styles.LinkWrapper}>
                        <li className={styles.MenuItem}>Notification</li>
                    </Link>

                    <Link to="/Account" className={styles.LinkWrapper}>
                        <li className={styles.MenuItem}>Account</li>
                    </Link>

                    <hr className={styles.Divider} />
                    <hr className={styles.Divider} />
                    <li className={`${styles.MenuItem} ${styles.Logout}`}>
                        <SignOutButton>
                            <span>Logout</span>
                        </SignOutButton>
                    </li>
                </ul>
            </div>
        </>
    );
}